import { loadRegionTree } from 'utils/tree'
import {getRegionList} from '@/api/get-data.js'
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件

export default {
  name: 'AddStreamNode',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: true,
      // 查询条件
      tableQueryParams: {
        regionId: 0,
        nodeId: 0,
        pageNum: 1,
        pageSize: 10
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 记录编辑
      addParams: {
        captureTaskId: 0,
        streamNodeIdCount: 0,
        streamNodeIds: []
      }
    }
  },
  props: {
    modalOpen: {
      type: Boolean,
      default: false
    },
    captureTaskId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mixins: [
    idNameMixin
  ],
  mounted () {
    // 获取区域列表
    this.getRegionList2()
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 获取区域列表
    getRegionList2() {
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)

        // 默认选中第一项
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 获取视频节点列表
    getStreamNodeList () {
      this.$http(this.$api.streamNodeList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
        }
      )
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick (obj) {
      if (this.tableQueryParams.regionId !== obj.id) {
        this.tableQueryParams.regionId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getStreamNodeList()
      }
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
      this.addParams.streamNodeIdCount = this.tableSelectedIds.length
      this.addParams.streamNodeIds = this.tableSelectedIds
    },
    // 分页
    handleTableCurrentChange (val) {
      this.tableQueryParams.pageNum = val
      this.getStreamNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getStreamNodeList()
    },
    // 提交新增记录
    handleModalSubmit () {
      this.addParams.captureTaskId = this.captureTaskId
      this.$http(this.$api.addStreamNodeForCaptureTask, this.addParams).then(res => {
        if (res.code === 200) {
          this.$emit('submit', false)
          this.$refs.table.clearSelection()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    // 取消提交记录
    handleModalCancel () {
      this.$emit('cancel', false)
      this.$refs.table.clearSelection()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/captureTask/addStreamNode/AddStreamNode.js